import React, { useEffect, useState } from "react";
import axios from "axios";
import GammaModal from "../../components/Modals/BusinessIntelligence/GammaModal";
import { useOutletContext } from "react-router-dom";
import { motion } from "framer-motion";

function Gamma() {
  const [tab, setTab] = useState("recent");
  const [viewMode, setViewMode] = useState("grid");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [gammaList, setGammaList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRespose, setTotalResponse] = useState(0);
  const [filterBy, setFilterBy] = useState(""); // filter by creator
  const [sortBy, setSortBy] = useState("recent"); // recent/oldest
  const [showFilterPanel, setShowFilterPanel] = useState(false); // toggle panel
  const [audioFile, setAudioFile] = useState(null);
  const [transcription, setTranscription] = useState("");

  const { token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleAddNew = () => {
    setSelectedRow(null);
    setIsAddModalOpen(true);
  };

  useEffect(() => {
    fetchGammas();
  }, []);

  useEffect(() => {
    applyFilterSort();
  }, [gammaList, filterBy, sortBy]);

  const fetchGammas = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE_URL}/gamma/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTotalResponse(res.data.gammaCount?.[0]?.Total || 0);
      console.log(res.data.gammaList);

      setGammaList(res.data.gammaList || []);
    } catch (error) {
      console.error("Failed to fetch gamma list", error);
    } finally {
      setLoading(false);
    }
  };

  const applyFilterSort = () => {
    let list = [...gammaList];

    // Filter by creator
    if (filterBy) {
      list = list.filter((item) =>
        item.name.toLowerCase().includes(filterBy.toLowerCase()),
      );
    }

    // Sort by date
    list.sort((a, b) => {
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return sortBy === "recent" ? dateB - dateA : dateA - dateB;
    });

    setFilteredList(list);
  };

  // When a file is selected
  const handleFileChange = (e) => {
    setAudioFile(e.target.files[0]);
  };

  // Upload file to your Whisper API
  const handleUploadAudio = async () => {
    if (!audioFile) return alert("Please select an audio file first!");

    const formData = new FormData();
    formData.append("audio", audioFile);

    try {
      setLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/chatgpt/whisper_transcribe`, // your Node route
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log(response.data);

      setTranscription(response.data.transcript);
    } catch (error) {
      console.error("Audio upload failed:", error);
      alert("Failed to transcribe audio");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="content">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">AI Presentations</h2>
          </div>

          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            {/* Animated Filter Panel */}
            <motion.div
              initial={{ width: 0, opacity: 0 }}
              animate={
                showFilterPanel
                  ? { width: 280, opacity: 1, marginRight: "1rem" }
                  : { width: 0, opacity: 0, marginRight: 0 }
              }
              transition={{ type: "spring", stiffness: 150, damping: 25 }}
              style={{ display: "flex", gap: "0.5rem" }}
              className="align-items-center"
              id="filter-panel"
              aria-hidden={!showFilterPanel}
            >
              {showFilterPanel && (
                <>
                  {/* Filter Input */}
                  <input
                    type="text"
                    placeholder="Filter by creator..."
                    className="form-control form-control-sm"
                    value={filterBy}
                    onChange={(e) => setFilterBy(e.target.value)}
                    style={{ width: 150 }}
                    aria-label="Filter by creator"
                  />

                  {/* Sort Select */}
                  <select
                    className="form-select form-select-sm ms-2"
                    style={{ width: 120 }}
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    aria-label="Sort presentations"
                  >
                    <option value="recent">Recent</option>
                    <option value="oldest">Oldest</option>
                  </select>
                </>
              )}
            </motion.div>

            {/* Filter Button */}
            <button
              onClick={() => setShowFilterPanel((prev) => !prev)}
              className="btn btn-outline-primary d-flex align-items-center gap-2 px-4 py-2 me-2"
              aria-expanded={showFilterPanel}
              aria-controls="filter-panel"
              aria-label="Toggle filter panel"
            >
              🔍
              <span className="d-none d-sm-inline">Filter</span>
              <span className="d-inline d-sm-none">Filter</span>
            </button>

            {/* Create New Button */}
            <button
              onClick={handleAddNew}
              className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2"
            >
              ✨<span className="d-none d-sm-inline">Create New</span>
              <span className="d-inline d-sm-none">Create</span>
            </button>
            {/* Create PPT Button */}
          </div>
        </div>
        {/* /Breadcrumb */}

        <div className="card">
          <div className="card-body p-3">
            <div className="d-flex align-items-center justify-content-between">
              <h5>{totalRespose} Presentations</h5>
            </div>
          </div>
        </div>

        <img src="https://gamma.app/docs/eo2dtokxqd1eh56" alt="" />

        {/* Job Cards */}
        <div className="row mt-3">
          {loading && <p className="text-center">Loading...</p>}

          {!loading && filteredList.length === 0 && (
            <p className="text-center">No Presentation found</p>
          )}

          {filteredList.map((item, index) => (
            <motion.div
              className="col-xl-3 col-lg-4 col-md-6"
              key={item.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              whileHover={{ scale: 1.03 }}
            >
              <div
                className="card"
                onClick={() => {
                  console.log("OPENING GAMMA URL:", item.gammaUrl);
                  window.open(item.gammaUrl, "_blank", "noopener,noreferrer");
                }}
                style={{
                  position: "relative",
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  cursor: "pointer",
                  border: "none",
                  transition: "transform 0.01s",
                }}
              >
                {/* Top area with animated gradient */}
                <div
                  style={{
                    height: "73px",
                    position: "relative",
                    padding: "1rem",
                    background:
                      "linear-gradient(270deg, #3B82F6, #9333EA, #10B981, #F59E0B)",
                    backgroundSize: "600% 600%",
                    display: "flex",
                    alignItems: "flex-end",
                    borderBottom: "1px solid rgba(0,0,0,0.05)",
                    color: "#fff",
                    animation: "gradientShift 10s ease infinite",
                  }}
                >
                  {/* Slide count badge */}
                  <span
                    style={{
                      position: "absolute",
                      top: "12px",
                      right: "12px",
                      backgroundColor: "#fff",
                      color: "#000",
                      borderRadius: "9999px",
                      padding: "4px 10px",
                      fontSize: "0.75rem",
                      fontWeight: "600",
                      userSelect: "none",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                      zIndex: 1,
                    }}
                  >
                    {item.slidesCount || "N/A"} slides
                  </span>
                </div>

                {/* Content area */}
                <div style={{ padding: "1rem" }}>
                  <h5
                    style={{
                      fontWeight: "700",
                      color: "#111827",
                      marginBottom: "0.3rem",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={item.title}
                  >
                    {item.title || "Untitled Presentation"}
                  </h5>

                  <p
                    style={{
                      color: "#6B7280",
                      marginBottom: "0.3rem",
                      fontSize: "0.875rem",
                      fontWeight: "400",
                    }}
                  >
                    by {item.name}
                  </p>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#6B7280",
                      fontSize: "0.875rem",
                      gap: "0.3rem",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      stroke="#6B7280"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      width="16"
                      height="16"
                    >
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                    <span>
                      {new Date(item.created_at).toLocaleDateString(undefined, {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </span>
                  </div>
                </div>

                {/* Gradient animation keyframes */}
                <style>
                  {`
      @keyframes gradientShift {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }
    `}
                </style>
              </div>
            </motion.div>
          ))}
        </div>

        {isAddModalOpen && (
          <GammaModal
            show={isAddModalOpen}
            onClose={() => setIsAddModalOpen(false)}
            defaultValues={selectedRow}
          />
        )}
      </div>
    </>
  );
}

export default Gamma;
